import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anonymous
  const [config, setConfig] = useState({ brand: "Tele-VOX", jitsi_domain: "", languages: ["ru", "uz", "en", "tg"], google_auth: true });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
    // CRITICAL: returning from OAuth (#session_id=) — AuthCallback establishes the session first.
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (config?.brand) document.title = config.brand;
  }, [config]);

  const login = useCallback((payload) => {
    setToken(payload.token);
    setUser(payload.user);
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    setToken(null);
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, config, login, logout, refresh, setUser }), [user, config, login, logout, refresh]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
